import { createContext } from 'react';

interface MainSidebarContextType {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  toggle: () => void;
}

export const MainSidebarContext = createContext<MainSidebarContextType | null>(
  null
);
